var config = {
    DEBUG: process.env.REACT_APP_DEBUG,
    DEBUG_WECHAT: process.env.REACT_APP_DEBUG_WECHAT,
    FAKE_TOKEN: process.env.REACT_APP_FAKE_TOKEN,
    BASE_URL: process.env.REACT_APP_BASE_URL || 'https://h5.congmingpai.com',
    API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT || 'https://h5.congmingpai.com/api',
    CDN_URL: process.env.REACT_APP_CDN_URL || 'http://static.congmingpai.com',
    TRANSITION_TIMEOUT: 300,
    CDN_DOMAIN: "https://cdn.frontend.congmingpai.com",
};
console.log('CONFIG:', config);
export { config };
//# sourceMappingURL=config.js.map


//////////////////
// WEBPACK FOOTER
// ../core-h5/build/src/config.js
// module id = 114
// module chunks = 0